import { gql } from '@apollo/client'

export const CREATED_REPORT_QUERY = gql`
  query createdReport($filter: CreatedReportFilter!) {
    createdReport(filter: $filter) {
      mainPeriod {
        transferredCasesLegalAdvice
        transferredCasesAiv
        transferredCasesCourtRepresentation
        selfGeneratedCasesAiv
        selfGeneratedCasesCourtRepresentation
        totalLegalAdvice
        totalLegalAdviceInMediation
        totalAiv
        totalCourtRepresentation
        totalKlara
      }
      comparisionPeriod {
        transferredCasesLegalAdvice
        transferredCasesAiv
        transferredCasesCourtRepresentation
        selfGeneratedCasesAiv
        selfGeneratedCasesCourtRepresentation
        totalLegalAdvice
        totalLegalAdviceInMediation
        totalAiv
        totalCourtRepresentation
        totalKlara
      }
      diff {
        transferredCasesLegalAdvice
        transferredCasesAiv
        transferredCasesCourtRepresentation
        selfGeneratedCasesAiv
        selfGeneratedCasesCourtRepresentation
        totalLegalAdvice
        totalLegalAdviceInMediation
        totalAiv
        totalCourtRepresentation
        totalKlara
      }
      trend {
        transferredCasesLegalAdvice
        transferredCasesAiv
        transferredCasesCourtRepresentation
        selfGeneratedCasesAiv
        selfGeneratedCasesCourtRepresentation
        totalLegalAdvice
        totalLegalAdviceInMediation
        totalAiv
        totalCourtRepresentation
        totalKlara
      }
    }
  }
`
